import { render, staticRenderFns } from "./Mypage.vue?vue&type=template&id=b248a1a2&"
import script from "./Mypage.vue?vue&type=script&lang=js&"
export * from "./Mypage.vue?vue&type=script&lang=js&"
import style0 from "./Mypage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports